/** @jsx h */
import { h, Component } from 'preact';
import Page from './Page';
import { prompt } from './alert';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = { menu: false, nightMode: sessionStorage.nightMode || false };
    this.notify = () => this.forceUpdate();
  }

  componentDidMount() {
    this.props.model.subscribe(this.notify);
  }

  componentWillUpdate() {
    if (this.props.model.online !== this.online) {
      this.online = this.props.model.online;
      document.title = `on the same page${this.online ? '' : ' (offline)'}`;
    }
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.notify);
  }

  onShowMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ menu: true });
  }

  onHideMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ menu: false });
    this.svgEl.focus();
  }

  render() {
    if (this.props.model.unauthorized) {
      return undefined;
    }
    return (
      <div
        className={this.state.nightMode ? 'night' : ''}
        style={{
          position: 'relative',
          width: '100vw',
          height: '100vh',
          overflow: 'hidden',
        }}
      >
        {
          this.state.menu
            ? (
              <div style={{ position: 'absolute', zIndex: 3 }}>
                <div className="menu">
                  <div className="menu-header">
                    <div style={{ flex: 1 }}>
                      <h1>On the same page</h1>
                      <p className="menu-board-name">{this.props.model.boardName}</p>
                    </div>
                    <button type="button" className="btn-close" onClick={e => this.onHideMenu(e)} />
                  </div>
                  <ul>
                    <li>
                      <button type="button" onClick={() => { window.location.pathname = '/'; }}>
                        New
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={(e) => {
                          this.onHideMenu(e);
                          prompt({
                            title: 'Open',
                            content: 'Enter board name:',
                          }).then((name) => { window.location.pathname = name; }, () => {
                            this.svgEl.focus();
                          });
                        }}
                      >
                      Open…
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={(e) => {
                          this.onHideMenu(e);
                          prompt({
                            title: 'Rename',
                            content: 'Enter new board name:',
                          }).then(newName => this.props.model.renameBoard(newName), () => {
                            this.svgEl.focus();
                          });
                        }}
                      >
                      Change URL…
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={(e) => {
                          this.onHideMenu(e);
                          prompt({
                            title: 'Protect',
                            content: 'Set board password:',
                            password: true,
                          }).then((password) => {
                            this.props.model.protectBoard(password);
                            this.svgEl.focus();
                          }, () => {
                            this.svgEl.focus();
                          });
                        }}
                      >
                      Add password…
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={(e) => {
                          this.onHideMenu(e);
                          this.setState(state => ({ nightMode: !state.nightMode }));
                          sessionStorage.nightMode = this.state.nightMode;
                        }}
                      >
                        { this.state.nightMode ? 'Day mode' : 'Night mode' }
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          window.location.pathname = '/about';
                        }}
                      >
                        About
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            ) : ''
        }

        <button type="button" className="btn-menu" onClick={e => this.onShowMenu(e)} />

        <Page
          onRef={(el) => { this.svgEl = el; }}
          elements={this.props.model.elements}
          pathStart={xy => this.props.model.pathStart(xy)}
          pathAdd={xy => this.props.model.pathAdd(xy)}
          pathEnd={id => this.props.model.pathEnd(id)}
          textCreate={xys => this.props.model.textCreate(xys)}
          textUpdate={(id, text) => this.props.model.textUpdate(id, text)}
          textEnd={() => {}}
          remove={id => this.props.model.remove(id)}
          cursor={xy => this.props.model.cursor(xy)}
          undo={() => this.props.model.undo()}
          redo={() => this.props.model.redo()}
        />
      </div>
    );
  }
}
